import { __decorate } from "tslib";
import { Directive, ViewContainerRef } from "@angular/core";
let ViewApplicationHostDirective = class ViewApplicationHostDirective {
    viewContainerRef;
    constructor(viewContainerRef) {
        this.viewContainerRef = viewContainerRef;
    }
    static ctorParameters = () => [
        { type: ViewContainerRef }
    ];
};
ViewApplicationHostDirective = __decorate([
    Directive({
        selector: "[appViewApplicationHost]"
    })
], ViewApplicationHostDirective);
export { ViewApplicationHostDirective };
